/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom'
import {applyMiddleware, combineReducers, compose, createStore} from 'redux'
import {Provider} from 'react-redux'
import thunk from 'redux-thunk'
import {APP_CONTEXT_PATH} from './api/HttpUtils'
import {security} from './security/SecurityReducer'
import {fault} from './faults/FaultReducer'
import {asset} from './assets/AssetReducer'
import {fleet} from './fleets/FleetReducer'
import {users} from './admin/users/UsersReducer'
import {user} from './admin/users/UserReducer'
import {version} from './version/VersionReducer'
import {appConfigsReducer} from './admin/appConfig/AppConfigReducer'
import {learningLoopReducer} from './admin/learningLoop/LearningLoopReducer'
import {fleetsReducer} from './admin/fleets/FleetsReducer'
import {assetReducer} from './admin/assets/AssetReducer'

import 'semantic-ui-css/semantic.min.css'

import App from './App'
import registerServiceWorker from './registerServiceWorker'
import {addLocaleData, IntlProvider} from "react-intl";
import locale_en from 'react-intl/locale-data/en';
import locale_zh from 'react-intl/locale-data/zh';
import messages_en from "./lang/translations/en.json";
import messages_zh from "./lang/translations/zh.json";
import messages_en_hda from './lang/translations/en_hda.json';
import messages_zh_hda from './lang/translations/zh_hda.json';
import './utils/polyfill/Array.find.js'
import './utils/polyfill/Array.findIndex.js'
import './utils/polyfill/Array.from.js'
import './utils/polyfill/Array.includes.js'
import './utils/polyfill/Element.closest.js'
import './utils/polyfill/String.startsWith.js'
import './utils/polyfill/String.includes.js'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
    combineReducers({security, fault, asset, fleet, users, user, version, appConfigsReducer, learningLoopReducer, fleetsReducer, assetReducer}),
    composeEnhancers(applyMiddleware(thunk))
)

addLocaleData([...locale_en, ...locale_zh]);
const messages = {
    'en': messages_en,
    //for zh merge zh messages into en messages to get en messages as fallback if zh message is missing
    'zh': {
        ...messages_en,
        ...messages_zh,
    },
    //for en_hda merge en_hda messages into en messages to get en messages as fallback if en_hda message is missing
    'en_hda': {
        ...messages_en,
        ...messages_en_hda,
    },
    //for zh_hda merge zh_hda messages into en messages and en_hda messages to get en messages and en_hda messages as fallback if zh_hda message is missing
    'zh_hda': {
        ...messages_en,
        ...messages_en_hda,
        ...messages_zh,
        ...messages_zh_hda,
    },
};

const browserLocale = navigator.language.split(/[-_]/)[0]
const defaultLocale = messages.hasOwnProperty(browserLocale) ? browserLocale : 'en'

let currentLocale = localStorage.getItem('lang')
if (!currentLocale) {
    currentLocale = defaultLocale;
    localStorage.setItem('lang', defaultLocale);
}

ReactDOM.render(
    <IntlProvider locale={currentLocale.includes('_hda') ? currentLocale.substring(0, currentLocale.indexOf('_hda')) : currentLocale} messages={messages[currentLocale]}>
        <BrowserRouter basename={APP_CONTEXT_PATH}>
            <Provider store={store}>
                <App/>
            </Provider>
        </BrowserRouter>
    </IntlProvider>, document.getElementById('root'))


registerServiceWorker();
